import { APP_KIND } from "core/consts";
import { AppType, Env } from "core/types";
import { ENV_DEMO, ENV_DEVELOPMENT, ENV_PREPROD, ENV_STAGING } from ".";

export const LOGIN_SUGGESTIONS: {
  app: AppType;
  email: string;
  env: Env[];
  label: string;
  password: string;
}[] = [
  // Sender app
  {
    app: APP_KIND.APP_CLINIC,
    email: "careseeker_staff",
    env: [ENV_STAGING, ENV_DEVELOPMENT],
    label: "careseeker_staff",
    password: "test",
  },
  {
    app: APP_KIND.APP_CLINIC,
    email: "user3@test4recare.com",
    env: [ENV_STAGING, ENV_DEVELOPMENT],
    label: "SSO",
    password: "",
  },
  {
    app: APP_KIND.APP_CLINIC,
    email: "testsenderuser@recaresolutions.com",
    env: [ENV_PREPROD, ENV_DEMO],
    label: "testsenderuser",
    password: "6PXA?zE5oL?by8$z",
  },
  // Receiver app
  {
    app: APP_KIND.APP_CAREPROVIDER,
    email: "careprovider_staff",
    env: [ENV_STAGING, ENV_DEVELOPMENT],
    label: "careprovider_staff",
    password: "test",
  },
  {
    app: APP_KIND.APP_CAREPROVIDER,
    email: "testpartneruser@recaresolutions.com",
    env: [ENV_PREPROD, ENV_DEMO],
    label: "testpartneruser",
    password: "YXds+)hX8m7S3h]Z",
  },
  {
    app: APP_KIND.APP_CAREPROVIDER,
    email: "testpartneruser2@recaresolutions.com",
    env: [ENV_PREPROD, ENV_DEMO],
    label: "testpartneruser2",
    password: "f!#ttXqjH47RCA4S",
  },
  // ACP
  {
    app: APP_KIND.APP_ACP,
    email: "admin@recaresolutions.com",
    env: [ENV_STAGING, ENV_DEVELOPMENT],
    label: "admin",
    password: "acnDsBH0yyUmtiIJ",
  },
  {
    app: APP_KIND.APP_ACP,
    email: "sandra.muench@recaresolutions.com",
    env: [ENV_STAGING, ENV_DEVELOPMENT],
    label: "edit careseeker",
    password: "test",
  },
  {
    app: APP_KIND.APP_ACP,
    email: "testadminuser@recaresolutions.com",
    env: [ENV_PREPROD, ENV_DEMO],
    label: "testadminuser",
    password: "#6$#stoa8N7J4zHB",
  },
];
